module.exports = __webpack_public_path__ + "img/1F1EC-1F1F6.c3b932ca.svg";